import { ChartDomain, ChartRange, ChartScale } from '/src/lib/types';

/**
 * Scale
 */

export type ScaleProps = ChartScale;

export class Scale implements ScaleProps {
  scale: any;
  range?: ChartRange;
  domain?: ChartDomain;

  constructor(scale: any, range?: ChartRange, domain?: ChartDomain) {
    if (scale && (range || domain)) {
      this.scale = scale;
      this.range = range;
      this.domain = domain;

      // Create scale
      this.scale();

      if (this.range) {
        if (this.range.type) {
          this.range.type.toLowerCase();
          if (this.range.type === 'range') this.scale.range(this.range.values);
          if (this.range.type === 'round') this.scale.rangeRound(this.range.values);
          if (this.range.type === 'roundbands') this.scale.rangeRoundBands(this.range.values);
        } else this.scale.range(this.range.values);
      }

      if (this.domain) this.scale.domain(this.domain);
    }
  }
}
